(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var a11y = require('./../slate/a11y.js');
var rte = require('./../slate/rte.js');

// Common a11y fixes
a11y.pageLinkFocus($(window.location.hash));

$('.in-page-link').on('click', function(evt) {
  a11y.pageLinkFocus($(evt.currentTarget.hash));
});

// Wrap videos in div to force responsive layout.
rte.wrapTable();
rte.iframeReset();

},{"./../slate/a11y.js":2,"./../slate/rte.js":3}],2:[function(require,module,exports){
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

module.exports = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

},{}],3:[function(require,module,exports){
/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

module.exports = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

},{}],4:[function(require,module,exports){
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

var $newAddressForm = $('#AddressNewForm');

if ($newAddressForm.length) {
  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

// Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

// Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    // eslint-disable-next-line no-alert
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
}

},{}],5:[function(require,module,exports){
/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

var config = {
  recoverPasswordForm: '#RecoverPassword',
  hideRecoverPasswordLink: '#HideRecoverPasswordLink'
};


checkUrlHash();
resetPasswordSuccess();

$(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
$(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

function onShowHidePasswordForm(evt) {
  evt.preventDefault();
  toggleRecoverPasswordForm();
}

function checkUrlHash() {
  var hash = window.location.hash;

  // Allow deep linking to recover password form
  if (hash === '#recover') {
    toggleRecoverPasswordForm();
  }
}

/**
 *  Show/Hide recover password form
 */
function toggleRecoverPasswordForm() {
  $('#RecoverPasswordForm').toggleClass('hide');
  $('#CustomerLoginForm').toggleClass('hide');
}

/**
 *  Show reset password success message
 */
function resetPasswordSuccess() {
  var $formState = $('.reset-password-success');

  // check if reset password form was successfully submited.
  if (!$formState.length) {
    return;
  }

  // show success message
  $('#ResetSuccess').removeClass('hide');
}

},{}],6:[function(require,module,exports){
/**
 * Gift Card Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Gift Card template.
 */

if ($('body').hasClass('template-giftcard')) {

  var config = {
    qrCode: '#QrCode',
    printButton: '#PrintGiftCard',
    giftCardCode: '.giftcard__code'
  };

  var $qrCode = $(config.qrCode);

  // eslint-disable-next-line no-new
  new QRCode($qrCode[0], {
    text: $qrCode.attr('data-identifier'),
    width: 120,
    height: 120
  });

  $(config.printButton).on('click', function() {
    window.print();
  });

// Auto-select gift card code on click, based on ID passed to the function
  $(config.giftCardCode).on('click', {element: 'GiftCardDigits'}, selectText);
}

function selectText(evt) {
  var text = document.getElementById(evt.data.element);
  var range = '';

  if (document.body.createTextRange) { // ms method
    range = document.body.createTextRange();
    range.moveToElementText(text);
    range.select();
  } else if (window.getSelection) { // moz, opera, webkit method
    var selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents(text);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}

},{}],7:[function(require,module,exports){
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

var cache = {
  $addToCart: $('#AddToCart'),
  $productPrice: $('#ProductPrice'),
  $comparePrice: $('#ComparePrice'),
  $addToCartText: $('#AddToCartText'),
  $productFeaturedImage: $('#ProductPhotoImg'),
  $productThumbs: $('#ProductThumbs').find('.product-single__thumbnail')
};

if (theme.productSingleObject) {
  Shopify.Image.preload(theme.productSingleObject.images, 'large');

  // eslint-disable-next-line no-new
  new Shopify.OptionSelectors('ProductSelect', {
    product: theme.productSingleObject,
    onVariantSelected: updateVariantSelection,
    enableHistoryState: true
  });

  // Clean up variant labels if the Shopify-defined
  // defaults are the only ones left
  simplifyVariantLabels(theme.productSingleObject);
}

/**
 * Updates the product page once a varient is selected. Changes button
 * status, text feedback, varient image, and prices.
 *
 * @param {Object} variant - Product object
 */
function updateVariantSelection(variant) {
  // Update cart button and text status
  if (!variant) {
    updateAddToCartState(false, theme.strings.unavailable);
    return;
  }

  if (variant.available) {
    updateAddToCartState(true, theme.strings.addToCart);
  } else {
    updateAddToCartState(false, theme.strings.soldOut);
  }

  // Update variant image, if one is set
  if (variant.featured_image) {
    updateProductImage(variant.featured_image.src);
  }

  // Update the product prices
  updateProductPrices(variant.price, variant.compare_at_price);
}

/**
 * Updates the DOM state of the cart
 *
 * @param {boolean} enabeled - Decides whether cart is enabled or disabled
 * @param {string} text - Updates the text notification content of the cart
 */
function updateAddToCartState(enabeled, text) {
  cache.$addToCart.prop('disabled', !enabeled);
  cache.$addToCartText.html(text);
}

/**
 * Updates the DOM with specified prices
 *
 * @param {string} productPrice - The current price of the product
 * @param {string} comparePrice - The original price of the product
 */
function updateProductPrices(productPrice, comparePrice) {
  cache.$productPrice
    .html(Shopify.formatMoney(productPrice, theme.moneyFormat));

  if (comparePrice > productPrice) {
    cache.$comparePrice
      .html(Shopify.formatMoney(comparePrice, theme.moneyFormat))
      .removeClass('hide');
  } else {
    cache.$comparePrice
      .addClass('hide');
  }
}

/**
 *  Adjust option_selection.js labels based on variant default values
 */
function simplifyVariantLabels(product) {
  // option_selection.js does not add a label if there is only one variant
  // option. Add one as long as it is not 'Title' (Shopify's default), add
  // one.
  if (product.options.length === 1 && product.options[0] !== 'Title') {
    $('.selector-wrapper:eq(0)').prepend('<label for="ProductSelect-option-0">' + product.options[0] + '</label>');
  }

  // Hide variant dropdown if only one exists and title contains 'Default'
  if (product.variants.length && product.variants[0].title.indexOf('Default') >= 0) {
    $('.selector-wrapper').hide();
  }
}

/**
 * Updates the DOM with the specified image URL
 *
 * @param {string} src - Image src URL
 */
function updateProductImage(src) {
  var size = Shopify.Image.imageSize(cache.$productFeaturedImage.attr('src'));
  var sizedImgUrl = Shopify.Image.getSizedImageUrl(src, size);

  $('#ProductPhotoImg').attr('src', sizedImgUrl);
}

},{}],8:[function(require,module,exports){
$(document).ready(function() {
  // GLOBAL SCRIPTS
  require('./global/global.js');

  // TEMPLATE SCRIPTS
  require('./templates/customers-addresses.js');
  require('./templates/giftcard.js');
  require('./templates/customers-login.js');
  require('./templates/product.js');

  // Custom theme script
  // ---------------------------------------------------------------------------

});

},{"./global/global.js":1,"./templates/customers-addresses.js":4,"./templates/customers-login.js":5,"./templates/giftcard.js":6,"./templates/product.js":7}]},{},[8]);
